import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function PaymentCancelPage() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-slate-50">
      <div className="max-w-md w-full mx-auto p-8 bg-white rounded-sm shadow-lg text-center" data-testid="payment-cancel">
        <div className="h-20 w-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="h-10 w-10 text-amber-600" />
        </div>
        <h2 className="font-['Playfair_Display'] text-2xl font-bold text-[#0F172A] mb-4">
          Payment Cancelled
        </h2>
        <p className="text-slate-600 mb-6">
          Your payment was cancelled. No charges have been made. 
          You can try again when you're ready.
        </p>
        <div className="flex flex-col gap-3">
          <Link to="/member">
            <Button 
              className="w-full bg-[#0F172A] text-white hover:bg-[#0F172A]/90"
              data-testid="return-dashboard-btn"
            >
              Return to Dashboard
            </Button>
          </Link>
          <Link to="/">
            <Button variant="outline" className="w-full">
              Back to Home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
